import * as newDashboardTypes from './newDashboardTypes';

const initialState = {
  caseId: null,
  caseNumber: null,
  isLoaded: true,
  isCaseNumberLoaded: true,
  resetMessageCompose: false,
  refreshMessageCount: false,
};
const newDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case newDashboardTypes.SET_COMPOSE_CLICK:
      return {
        ...state,
        composeClick: action.payload,
      };
    case newDashboardTypes.SET_CASE_ID:
      return {
        ...state,
        caseId: action.payload,
        isLoaded: false,
      };
    case newDashboardTypes.SET_CASE_NUMBER:
      return {
        ...state,
        caseNumber: action.payload,
        isCaseNumberLoaded: false,
      };
    case newDashboardTypes.SET_CASE_DETAIL:
      return {
        ...state,
        caseDetail: action.payload,
      };
    case newDashboardTypes.RESET_CASE_ID:
      return {
        ...state,
        isLoaded: true,
        isCaseNumberLoaded: true,
      };
    case newDashboardTypes.SET_SELECTED_TOGGLE_OPTION:
      return {
        ...state,
        isAllCases: action.payload,
      };
    case newDashboardTypes.RESET_SELECTED_TOGGLE_OPTION:
      return {
        ...state,
        isAllCases: null,
      };
    case newDashboardTypes.REFRESH_MESSAGE_COUNT:
      return {
        ...state,
        refreshMessageCount: action.payload,
      };
    default:
      return state;
  }
};

export default newDashboardReducer;
